export const createErrorWithCause = (message: string, cause?: unknown): Error => {
  const error = new Error(message);

  if (cause !== undefined) {
    Object.assign(error, { cause });
  }

  return error;
};
